"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditorDebugOverlay = void 0;
var utils_1 = require("@qwilr/kaleidoscope/utils");
var lodash_1 = require("lodash");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var EditorDebugOverlay = (0, mobx_react_1.observer)(function (_a) {
    var editorDebugStore = _a.editorDebugStore, editorId = _a.editorId;
    if ((0, lodash_1.isNil)(editorDebugStore.debugOverlayState) || editorDebugStore.debugOverlayState.editorId !== editorId) {
        return null;
    }
    return react_dom_1.default.createPortal(react_1.default.createElement("div", { className: "editor-debug-overlay", style: __assign({}, editorDebugStore.debugOverlayState.overlayProps) }), (0, utils_1.getPortalRoot)("editor-debug-overlay"));
});
exports.EditorDebugOverlay = EditorDebugOverlay;
